import '../styles/Maintenance.css';
import maintenance1 from '../imgs/maintenance1.png'; // Import your maintenance image
import maintenance2 from '../imgs/maintenance2.png'; // Import your maintenance image
import maintenance3 from '../imgs/maintenance3.png'; // Import your maintenance image
import maintenance4 from '../imgs/maintenance4.png'; // Import your maintenance image

const Maintenance = () => {
    const maintenanceImages = [
        maintenance1,
        maintenance2,
        maintenance3,
        maintenance4
    ];

    // Randomly select an image on page load
    const randomImage = maintenanceImages[Math.floor(Math.random() * maintenanceImages.length)];

    return (
        <div className="content">
            <div className="maintenance-container">
                <div className="maintenance-header">
                    <h1>ISN NETWORK</h1>
                    <h1>Maintenance Mode</h1>
                </div>
            <div className="maintenance-image">
                <img src={randomImage} alt="Maintenance" />
            </div>
            <div className="maintenance-content">
            <h2>We are currently undergoing maintenance.</h2>
                <div className="maintenance-item">
                    <h2 className="Schedule">Scheduled Maintenance:</h2>
                    <p>Maintenance will end: <span>N/A</span></p>
                    <p>Our team is working hard to improve the platform. We appreciate your patience!</p>
                </div>
            </div>
        </div>
        </div>
    );
}
export default Maintenance;